module.exports = "/templates/managereports.html";


//////////////////
// WEBPACK FOOTER
// ./src/templates/managereports.html
// module id = 454
// module chunks = 0